import { api, createCrudOperations } from "./api.js";
import { USER_TYPES, validateUserForm } from "../utils";

export const userService = {
  ...createCrudOperations("users"),

  create: async (data) => {
    const validation = validateUserForm(data);
    if (!validation.isValid) throw new Error(JSON.stringify(validation.errors));

    if (!Object.values(USER_TYPES).includes(data.user_type)) {
      throw new Error(
        JSON.stringify({
          user_type:
            'Le type doit être "member", "teacher", "board_member", "helper" ou "student"',
        }),
      );
    }

    const payload = {
      first_name: data.first_name.trim(),
      last_name: data.last_name.trim(),
      user_type: data.user_type,
      phone: data.phone?.trim() || null,
      email: data.email?.trim().toLowerCase() || null,
      activity_start_date: data.activity_start_date || null,
      activity_end_date: data.activity_end_date || null,
    };

    return api.post("/users", payload).then((r) => r.data);
  },

  update: async (id, data) => {
    const validation = validateUserForm(data);
    if (!validation.isValid) throw new Error(JSON.stringify(validation.errors));

    if (data.user_type && !Object.values(USER_TYPES).includes(data.user_type)) {
      throw new Error(
        JSON.stringify({
          user_type:
            'Le type doit être "member", "teacher", "board_member", "helper" ou "student"',
        }),
      );
    }

    const payload = {
      first_name: data.first_name?.trim(),
      last_name: data.last_name?.trim(),
      user_type: data.user_type,
      phone: data.phone?.trim() || null,
      email: data.email?.trim().toLowerCase() || null,
      activity_start_date: data.activity_start_date || null,
      activity_end_date: data.activity_end_date || null,
    };

    Object.keys(payload).forEach(
      (key) => payload[key] === undefined && delete payload[key],
    );
    return api.put(`/users/${id}`, payload).then((r) => r.data);
  },

  getByType: async (userType) => {
    const response = await api.get("/users", {
      params: { user_type: userType },
    });
    return response.data;
  },

  getTeachers: () => userService.getByType(USER_TYPES.TEACHER),
  getMembers: () => userService.getByType(USER_TYPES.MEMBER),
  getStudents: () => userService.getByType(USER_TYPES.STUDENT),
  getActive: async () => {
    const users = await userService.getAll();
    const now = new Date();
    return users.filter((u) => {
      const start = u.activity_start_date
        ? new Date(u.activity_start_date)
        : null;
      const end = u.activity_end_date ? new Date(u.activity_end_date) : null;
      if (start && start > now) return false;
      if (end && end < now) return false;
      return true;
    });
  },

  getUserTypes: () => Object.values(USER_TYPES),
};

export default userService;
